import jQuery from "jQuery";
import * as facebook from "./facebook";
import * as unity from "./unity";

/** @namespace config.gameName */
/** @namespace config.webUrl */
/** @namespace config.platformData */
/** @namespace config.platformData.appId */
export let config;
export let loginData;
let fullScreenOn = false;
let callbacksOnLoginData = [];
const psCanvasLastFBUserId = "PS_CANVAS_LAST_FB_USER_ID";
const nativeVersion = "{NATIVE_VERSION}";

export function init(c) {
    config = c;

    if (facebook.isCanvas() && config.platformData.idFbUser) {
        const lastId = localStorage.getItem(psCanvasLastFBUserId);
        if (lastId !== config.platformData.idFbUser.toString()) {
            console.log("New FB user detected, puring Index DB");
            purgeIndexedDB();
            localStorage.setItem(psCanvasLastFBUserId, config.platformData.idFbUser);
        }
    }
}

export function getApiUrl(path, params) {
    let url = (config.webUrl + "/" + path).replace(/([^:]\/)\/+/g, "$1");

    if (params) {
        url += "?" + jQuery.param(params);
    }

    return url;
}

export function fetchJson(path, params) {
    return fetch(getApiUrl(path, params), {
        credentials: "same-origin"
    }).then(response => response.json());
}

export function readFromLocalStorage(key) {
    return new Promise(function (resolve) {
        const val = localStorage.getItem(key);
        resolve(val ? String(localStorage.getItem(key)) : "");
    });
}

export function writeToLocalStorage(key, value) {
    return new Promise(function (resolve) {
        localStorage.setItem(key, value);
        resolve();
    });
}

export function getPageInfo(callback) {
    if (typeof callback !== "function") return;

    if (facebook.isCanvas()) {
        facebook.getPageInfo(callback);
    } else {
        callback({
            clientHeight: window.innerHeight,
            clientWidth: window.innerWidth,
            offsetTop: 0,
            offsetBottom: 0,
        });
    }
}

export function loadScript(url, callback) {

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = url;
    s.async = true;

    if (typeof callback === "function") {
        s.onreadystatechange = callback;
        s.onload = callback;
    }

    const x = document.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(s, x);
}

export function setLoginData(rawData) {
    const data = JSON.parse(rawData);
    console.log("[w] setLoginData: ", data);

    if (!loginData && data) {
        loginData = data;
        while (callbacksOnLoginData.length > 0) callbacksOnLoginData.pop()(loginData);
    }
}

export function onLoginData(callback) {
    if (loginData) callback(loginData);
    else callbacksOnLoginData.push(callback);
}

export function purgeIndexedDB() {
    try {
        indexedDB.deleteDatabase("/idbfs");
        indexedDB.deleteDatabase("/idbfs-test");
        indexedDB.deleteDatabase("CachedXMLHttpRequest");
        indexedDB.deleteDatabase("UnityCache");
    } catch(e) {
        console.log("Erro", e);
    }    
}

export function showZendeskMenu() {
    sendCommonPluginData({
        type: "showZendeskMenu",
    });
}

export function openWindow(winName, w, h, submitFormId) {

    const left = screen.width / 2 - w / 2;
    const top = screen.height / 2 - h / 2;

    window.open("", winName, `width=${w}, height=${h}, top=${top}, left=${left},menubar=no,location=yes,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no`);
    if (submitFormId) {
        window.setTimeout(`document.getElementById("${submitFormId}").submit();`, 50);
    }
}

export function requestFullscreen() {
    var body = document.body;
    if (body.requestFullscreen) 
        body.requestFullscreen();
    else if (body.mozRequestFullScreen) /* Firefox */
        body.mozRequestFullScreen();
    else if (body.webkitRequestFullscreen) /* Chrome, Safari and Opera */
        body.webkitRequestFullscreen();
    else if (body.msRequestFullscreen) /* IE/Edge */
        body.msRequestFullscreen();
}

export function exitFullscreen() {
    if (document.exitFullscreen) 
        document.exitFullscreen();
    else if (document.mozCancelFullScreen) /* Firefox */
        document.mozCancelFullScreen();
    else if (document.webkitExitFullscreen) /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
    else if (document.msExitFullscreen) /* IE/Edge */
        document.msExitFullscreen();    
}

export function isFullscreen() {
    return fullScreenOn;
}

export function toggleFullscreen() {
    if(fullScreenOn)
        exitFullscreen();
    else
        requestFullscreen();
}

export function customLogin() {
    return facebook.login();
}

export function getNativeVersion() {
    return nativeVersion;
}

document.addEventListener("fullscreenchange", function() {
    fullScreenOn = !fullScreenOn;
});

function sendCommonPluginData(params) {
    if (unity.isReady()) unity.sendData(unity.webCommonPlugin, params);
}  